// src/mappers/purchase/excludedSubjectMapper.ts
import { PurchaseDetail, PurchaseFormValues } from '../../types/purchases/BasePurchase';

export function mapExcludedSubjectPurchaseToFormValues(purchase: PurchaseDetail): PurchaseFormValues {
  const excluded = purchase.excludedSubjectDetails;

  const subtotal = excluded?.subtotal ?? 0;
  const incomeTaxWithholding = excluded?.incomeTaxWithholding ?? 0;
  const total = excluded?.total ?? 0;

  return {
    id: purchase.id,
    documentType: purchase.documentType,
    documentNumber: purchase.documentNumber,
    correlative: purchase.correlative,
    purchaseDate: purchase.purchaseDate,
    supplier: purchase.supplier,
    comments: purchase.comments || '',
    cancellationReason: purchase.cancellationReason || '',
    products: excluded?.products || [],
    paymentCondition: purchase.paymentCondition || null,
    paymentMethod: purchase.paymentMethod || null,

    // Totales para sujeto excluido
    subtotal,
    incomeTaxWithholding,
    total,

    // Campos no aplicables aquí
    taxableSubtotal: 0,
    perceivedIVA: 0,
    totalToRefund: null,
    totalQuantity: null,
    netAmount: null,
    freight: null,
    insurance: null,
    fauca: null,
    otherCosts: null,
    exportIva: null,
    totalCost: null,
  };
}
